// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"DVxcHT","header":"xbq5ec","content":"KzPW8Y","expanded":"v2BfhR","title":"XlXEKg"};